"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _default(date) {
  if (!date) return date;

  var isMoment = _moment.default.isMoment(date);

  var dateObject = isMoment ? date : (0, _moment.default)(date, 'x');
  return dateObject.toISOString();
}